import { result } from "lodash";
import { useMemo } from "react";
import { useSelector } from "react-redux";

export const checkPermission = ({ permission = '', defaultValue = false, permissions = {} }) => {
  return result(permissions, permission, defaultValue);
}

export const checkPermissionList = ({ permissionsList = [], defaultValue = false, permissions = {} }) => {
  return !!permissionsList
    .map((permission) => checkPermission({ permission, defaultValue, permissions }))
    .filter((v) => !!v)
    .length;
}

export const usePermissions = ({ permission = '', defaultValue = false }) => {
  const { user } = useSelector((state) => state.authentication);
  const permissions = useMemo(() => user?.role?.permissions || {}, [user]);
  const value = useMemo(() => checkPermission({ permissions, permission, defaultValue }), [permissions]);
  return value;
};
